<template>
    <div class="gs-billing-detail">
        <div class="gs-billing-detail__card">
          <div class="gs-billing-detail__grid">
            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_analytics_customer')
                }}</label>
                <label class="text-sm text-grey-700 mb-2">{{ purchase.buyer_fullname }}</label>
            </div>
            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">Email</label>
                <label class="text-sm text-grey-700 mb-2">{{ purchase.buyer_email }}</label>
            </div>

            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_phone') }}</label>
                <label class="text-sm text-grey-700 mb-2">{{
                    purchase.buyer_phone && purchase.buyer_phone.trim() != '' ? purchase.buyer_phone : 'N/A'
                }}</label>
            </div>

            <div class="gs-billing-detail__field gs-billing-detail__field--wide">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_company') }}</label>
                <label class="text-sm text-grey-700 mb-2">{{
                    purchase.buyer_company && purchase.buyer_company.trim() != '' ? purchase.buyer_company :
                    'N/A'
                }}</label>
            </div>

            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_ip_address') }}</label>
                <label class="text-sm text-grey-700 mb-2">{{ purchase.buyer_ip }}</label>
            </div>
            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_address') }}</label>
                <label class="text-sm text-grey-700 mb-2">{{
                    purchase.buyer_address && purchase.buyer_address.trim() != '' ? purchase.buyer_address :
                    'N/A'
                }}</label>
            </div>
            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_city') }}</label>
                <label class="text-sm text-grey-700 mb-2">{{
                    purchase.buyer_city && purchase.buyer_city.trim() != '' ? purchase.buyer_city : 'N/A'
                }}</label>
            </div>

            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_state') }}</label>
                <label class="text-sm text-grey-700 mb-2">{{
                    purchase.buyer_state && purchase.buyer_state.trim() != '' ? purchase.buyer_state : 'N/A'
                }}</label>
            </div>
            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_country') }}</label>
                <label class="text-sm text-grey-700 mb-2">{{
                    purchase.buyer_country && purchase.buyer_country.trim() != '' ? purchase.buyer_country :
                    'N/A'
                }}</label>
            </div>
            <div class="gs-billing-detail__field">
                <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_zipcode') }}</label>
                <label class="text-sm text-grey-700 mb-2">{{
                    purchase.buyer_postal_code && purchase.buyer_postal_code.trim() != '' ?
                    purchase.buyer_postal_code : 'N/A'
                }}</label>
            </div>
          </div>
        </div>
    </div>
</template>
<style scoped>
.gs-billing-detail__card {
  padding: 20px 24px;
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  background: var(--gs-surface);
  box-shadow: var(--gs-shadow-sm);
}

.gs-billing-detail__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px 20px;
}

.gs-billing-detail__field {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 6px;
}

.gs-billing-detail__field--wide {
  grid-column: 1 / -1;
}

.gs-billing-detail__field label:first-child {
  color: var(--gs-muted-foreground);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
}

.gs-billing-detail__field label:last-child {
  overflow-wrap: anywhere;
  color: var(--gs-foreground);
  font-size: 14px;
  line-height: 1.5;
}

@media (max-width: 720px) {
  .gs-billing-detail__card {
    padding: 16px;
  }

  .gs-billing-detail__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 480px) {
  .gs-billing-detail__grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
<script>
export default {

    props: {
        purchase: {
            required: true
        }
    }
}
</script>
